import React, { useState } from 'react';
import './SalesTeam.css';

const Projects = () => {
  // Initial projects data - 3 records
  const [projects, setProjects] = useState([
    {
      id: 1,
      projectNo: 'PRJ-7741',
      client: 'Acme Industries',
      po: 'PO-2025-014',
      value: '₹9,20,000',
      owner: 'Priya (Exec)',
      startDate: '2025-04-22',
      deliveryDate: '2025-06-03',
      status: 'In Progress'
    },
    {
      id: 2,
      projectNo: 'PRJ-7742',
      client: 'Nimbus Tech',
      po: 'PO-2025-023',
      value: '₹16,50,000',
      owner: 'Karan (Exec)',
      startDate: '2025-04-19',
      deliveryDate: '2025-06-15',
      status: 'Planning'
    },
    {
      id: 3,
      projectNo: 'PRJ-7743',
      client: 'Orbit Logistics',
      po: 'PO-2025-031',
      value: '₹13,20,000',
      owner: 'Priya (Exec)',
      startDate: '2025-04-16',
      deliveryDate: '2025-06-28',
      status: 'In Progress'
    }
  ]);

  // Client options for dropdown
  const clientOptions = [
    { id: 'CLT-001', name: 'Acme Industries' },
    { id: 'CLT-002', name: 'Nimbus Tech' },
    { id: 'CLT-003', name: 'Orbit Logistics' },
    { id: 'CLT-004', name: 'BluePeak Foods' }
  ];

  // PO options
  const poOptions = [
    { id: 'PO-2025-014', client: 'Acme Industries', value: '₹9,20,000' },
    { id: 'PO-2025-023', client: 'Nimbus Tech', value: '₹16,50,000' },
    { id: 'PO-2025-031', client: 'Orbit Logistics', value: '₹13,20,000' },
    { id: 'PO-2025-045', client: 'BluePeak Foods', value: '₹7,80,000' }
  ];

  // Status options
  const statusOptions = ['Planning', 'In Progress', 'On Hold', 'Review', 'Completed', 'Delayed'];

  // Modal states
  const [isAddProjectModalOpen, setIsAddProjectModalOpen] = useState(false);

  // Form state for new project
  const [formData, setFormData] = useState({
    client: '',
    linkedPO: '',
    value: '',
    startDate: '',
    deliveryDate: '',
    owner: 'Aarav (Admin)'
  });

  // Owner options
  const ownerOptions = ['Aarav (Admin)', 'Priya (Exec)', 'Karan (Exec)', 'Neha (Manager)', 'Raj (Sales)'];

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Handle PO selection - auto fill value
  const handlePOChange = (e) => {
    const poId = e.target.value;
    const selectedPO = poOptions.find(po => po.id === poId);
    setFormData(prev => ({
      ...prev,
      linkedPO: poId,
      value: selectedPO ? selectedPO.value : '',
      client: selectedPO ? selectedPO.client : prev.client
    }));
  };

  // Handle client selection
  const handleClientChange = (e) => {
    const clientName = e.target.value;
    setFormData(prev => ({
      ...prev,
      client: clientName
    }));
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  // Generate next project number
  const generateProjectNo = () => {
    const lastProject = projects[projects.length - 1];
    if (lastProject) {
      const lastNumber = parseInt(lastProject.projectNo.split('-')[1]);
      const nextNumber = lastNumber + 1;
      return `PRJ-${nextNumber}`;
    }
    return 'PRJ-7744';
  };

  // Add new project
  const handleAddProject = () => {
    if (!formData.client || !formData.startDate || !formData.deliveryDate) {
      alert('Please fill all required fields: Client, Start Date, and Delivery Date');
      return;
    }

    const newProjectNo = generateProjectNo();

    const newProject = {
      id: projects.length + 1,
      projectNo: newProjectNo,
      client: formData.client,
      po: formData.linkedPO || '—',
      value: formData.value || '—',
      owner: formData.owner,
      startDate: formData.startDate,
      deliveryDate: formData.deliveryDate,
      status: 'Planning'
    };

    setProjects([...projects, newProject]);

    // Reset form
    setFormData({
      client: '',
      linkedPO: '',
      value: '',
      startDate: '',
      deliveryDate: '',
      owner: 'Aarav (Admin)'
    });

    setIsAddProjectModalOpen(false);
    alert(`Project ${newProjectNo} created successfully!`);
  };

  // Update project status
  const updateStatus = (projectId, newStatus) => {
    const updatedProjects = projects.map(project =>
      project.id === projectId ? { ...project, status: newStatus } : project
    );
    setProjects(updatedProjects);
    alert(`Project status updated to "${newStatus}"`);
  };

  return (
    <div className="prj-container">
      <div className="prj-wrapper">
        {/* Header Section */}
        <div className="prj-header">
          <div className="prj-header-top">
            <div className="prj-header-left">
              <h1 className="prj-title">Projects</h1>
              <span className="prj-badge">ORG-WIDE VIEW</span>
            </div>
            <button className="prj-add-btn" onClick={() => setIsAddProjectModalOpen(true)}>
              + Add Project
            </button>
          </div>
          <p className="prj-description">Auto-created on PO logging. Update status inline.</p>
        </div>

        {/* Projects Table */}
        <div className="prj-table-section">
          <div className="prj-table-responsive">
            <table className="prj-table">
              <thead>
                <tr>
                  <th>PROJECT #</th>
                  <th>CLIENT</th>
                  <th>PO</th>
                  <th>VALUE</th>
                  <th>OWNER</th>
                  <th>START</th>
                  <th>DELIVERY</th>
                  <th>STATUS</th>
                  <th>UPDATE</th>
                </tr>
              </thead>
              <tbody>
                {projects.map((project) => (
                  <tr key={project.id}>
                    <td className="prj-cell-project-no">{project.projectNo}</td>
                    <td>{project.client}</td>
                    <td className="prj-cell-po">{project.po}</td>
                    <td className="prj-cell-value">{project.value}</td>
                    <td>{project.owner}</td>
                    <td>{formatDate(project.startDate)}</td>
                    <td>{formatDate(project.deliveryDate)}</td>
                    <td>
                      <span className={`prj-status-badge prj-status-${project.status.toLowerCase().replace(/\s+/g, '-')}`}>
                        {project.status}
                      </span>
                    </td>
                    <td>
                      <select
                        className="prj-status-select"
                        value={project.status}
                        onChange={(e) => updateStatus(project.id, e.target.value)}
                      >
                        {statusOptions.map(option => (
                          <option key={option} value={option}>{option}</option>
                        ))}
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Add Project Modal */}
      {isAddProjectModalOpen && (
        <div className="prj-modal-overlay" onClick={() => setIsAddProjectModalOpen(false)}>
          <div className="prj-modal" onClick={(e) => e.stopPropagation()}>
            <div className="prj-modal-header">
              <h3>Add New Project</h3>
              <button className="prj-modal-close" onClick={() => setIsAddProjectModalOpen(false)}>×</button>
            </div>
            <div className="prj-modal-body">
              <div className="prj-form-group">
                <label>Client <span className="prj-required">*</span></label>
                <select name="client" value={formData.client} onChange={handleClientChange}>
                  <option value="">Select a client</option>
                  {clientOptions.map(client => (
                    <option key={client.id} value={client.name}>
                      {client.name} ({client.id})
                    </option>
                  ))}
                </select>
              </div>

              <div className="prj-form-group">
                <label>Linked PO (optional)</label>
                <select name="linkedPO" value={formData.linkedPO} onChange={handlePOChange}>
                  <option value="">— None —</option>
                  {poOptions.map(po => (
                    <option key={po.id} value={po.id}>
                      {po.id} - {po.client} ({po.value})
                    </option>
                  ))}
                </select>
              </div>

              <div className="prj-form-group">
                <label>Value (₹)</label>
                <input
                  type="text"
                  name="value"
                  value={formData.value}
                  onChange={handleInputChange}
                  placeholder="Auto-filled from PO or enter manually"
                  disabled={formData.linkedPO !== ''}
                  className={formData.linkedPO ? 'prj-disabled-input' : ''}
                />
              </div>

              <div className="prj-form-group">
                <label>Start date <span className="prj-required">*</span></label>
                <input
                  type="date"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleInputChange}
                />
              </div>

              <div className="prj-form-group">
                <label>Delivery date <span className="prj-required">*</span></label>
                <input
                  type="date"
                  name="deliveryDate"
                  value={formData.deliveryDate}
                  onChange={handleInputChange}
                />
              </div>

              <div className="prj-form-group">
                <label>Owner <span className="prj-required">*</span></label>
                <select name="owner" value={formData.owner} onChange={handleInputChange}>
                  {ownerOptions.map(opt => <option key={opt} value={opt}>{opt}</option>)}
                </select>
              </div>
            </div>
            <div className="prj-modal-footer">
              <button className="prj-cancel-button" onClick={() => setIsAddProjectModalOpen(false)}>Cancel</button>
              <button className="prj-save-button" onClick={handleAddProject}>Save project</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;